import { createPivotTableReducer } from 'reducers/pivotTable'
import { combineReducers } from 'redux'

export const amendmentsPivotTableKey = 'quotingContext.selected.amendments.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: amendmentsPivotTableKey, defaultSortColumn: 'createdDateRaw', defaultSortDirection: 'desc'}),
})
